import React from 'react';

import { Box } from '@chakra-ui/react';
import ProfileFieldCard from './ProfileFieldCard';
import { useUser } from '../../../../hooks/V2/useUser';

const CollegeEmailAddress = () => {
	const { data: profile } = useUser();
	return (
		<Box>
			<ProfileFieldCard keyName="email" title={profile?.email || ''} heading="College Email Address" />
		</Box>
	);
};

export default CollegeEmailAddress;
